// Supported UI locales — the single source of truth shared across packages.
//
// This set is mirrored by:
//   - the users.locale CHECK constraint
//     (db/migrations/1746900000000_add-users-locale.sql)
//   - the react-i18next bootstrap (packages/web/src/i18n/index.ts)
//
// Phase 1: es-MX is the maintained translation; English is partial — only
// platform-staff-facing strings — per architecture/frontend-architecture.md
// §13.4. Adding a locale is an additive change here + a CHECK-constraint
// migration.

/**
 * The UI locales the platform accepts — mirrored by the users.locale CHECK
 * constraint and the react-i18next bootstrap, so adding one is a code change
 * PLUS a migration.
 */
export const SUPPORTED_LOCALES = ['es-MX', 'en'] as const

export type Locale = (typeof SUPPORTED_LOCALES)[number]

/** Product-market default — matches the users.locale column default. */
export const DEFAULT_LOCALE: Locale = 'es-MX'
